import * as types from "../../mutation-types.js";
import http from "@service/http";
import { tokenCall, restCall } from "@service/adapter";
import util from "@common/utils/util";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";

/**
 * 登陆-注册STORE
 */
const PAGENOPRO = "PAGENOPRO";
const LASTPAGEPRO = "LASTPAGEPRO";
const PROJECT_LISTS = "PROJECT_LISTS";

const PURCHASE_PAGENOPRO = "PURCHASE_PAGENOPRO";
const PURCHASE_LASTPAGEPRO = "PURCHASE_LASTPAGEPRO";
const PROJECT_PURCHASE_LISTS = "PROJECT_PURCHASE_LISTS";
const PROJECT_PURCHASE_PUBLICITY_LISTS = "PROJECT_PURCHASE_PUBLICITY_LISTS";
const PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO =
  "PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO";

const PROTECTION_LISTS = "PROTECTION_LISTS";
const REFUND_RECORD_LISTS = "REFUND_RECORD_LISTS";
const NEW_LISTS = "NEW_LISTS";
const AUTH_LISTS = "AUTH_LISTS";
export default {
  state: {
    projectLists: [],
    protectionLists: [],

    refundRecordLists: [],
    authLists: [],
    newLists: [],
    pageNoPro: 1,
    lastPagePro: 1,

    projectPurchaseLists: [],
    purchasePageNoPro: 1,
    purchaseLastPagePro: 1,

    projectPurchaseLists: [],
    purchasePageNoPro: 1,
    purchaseLastPagePro: 1,

    projectPurchasePublicityLists: [],
    projectPurchasePublicityPageNoPro: 1,
    projectPurchasePublicityLastPagePro: 1,
  },
  actions: {
    // getUserKey
    getUserKey({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sw/getUserKey",
        data,
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //修改密码
    resetPassword({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sw/resetPassword",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "修改密码失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 经销商登录
    agencyLogin({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/sw/login", data, "get")
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 退出
    agencyLogout({ commit }) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/sw/logout", {}, "get")
        .then((result) => {
          if (result) {
            return Promise.resolve(result);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取跟进人员列表
    listDealer({ commit }) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listDealer",
        {},
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取经销商
    listDeptMan({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listDeptMan",
        data,
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //通过静态值constCode获取字典数据
    constValue({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sm/const/constValue",
        data,
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取我的下属员工
    getMySubs({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sm/user/getMySubs",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取销售部门
    listDepart({ commit }) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listDepart",
        {},
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    listDepartByName({ commit }, deptName) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listDepartByName",
        {
          deptName: deptName,
        },
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    /*********************工程备案********************/

    //分页获取工程备案
    projectRecordPage({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall(Constant.tokenCallUrl + "/mxoa/projectRecord/page", data)
        .then((result) => {
          if (result && result.data) {
            commit(PROJECT_LISTS, result.data.list);
            commit(LASTPAGEPRO, result.data.lastPage);
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    projectListCanAuth({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listCanAuth",
        data,
        "get"
      )
        .then((result) => {
          if (result) {
            return Promise.resolve(result);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //保存工程备案
    projectRecordSave({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/save",
        data,
        "post"
      )
        .then((result) => {
          if (result) {
            return Promise.resolve(result);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //修改工程备案
    projectRecordUpdate({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/update",
        data
      )
        .then((result) => {
          if (result) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取工程备案详情
    getProjectById({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/getProjectById",
        data,
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    /*********************保护区********************/

    //分页获取保护区备案
    protectRecordPage({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall(Constant.tokenCallUrl + "/mxoa/protect/page", data)
        .then((result) => {
          if (result && result.data) {
            commit(PROJECT_LISTS, result.data.list);
            commit(LASTPAGEPRO, result.data.lastPage);
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //创建保护区备案
    protectCreate({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/protect/create", data)
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //修改保护区备案
    protectUpdate({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/protect/update", data)
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //保护区备案详情
    protectDetails({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/protect/details",
        data,
        "get"
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    /*********************保证金********************/

    //获取自己可退保证金的工程备案
    listCanRefund({ commit }) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listCanRefund",
        {},
        "get"
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //分页获取自己的退保证金工程
    refundRecordPage({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall(Constant.tokenCallUrl + "/mxoa/refundRecord/page", data)
        .then((result) => {
          if (result.code == 200) {
            commit(PROJECT_LISTS, result.data.list);
            commit(LASTPAGEPRO, result.data.lastPage);
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //创建
    refundRecordSave({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/refundRecord/save", data)
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //修改
    refundRecordUpdate({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/refundRecord/update",
        data
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //详情
    getRefundByRecId({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/refundRecord/getByRecId",
        data,
        "get"
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    /********************* 战略集采备案 ********************/

    // 分页获取战略集采备案
    getPageProjectPurchase({ commit }, data) {
      commit(PURCHASE_PAGENOPRO, data.pageNo);
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecordPurchase/page",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            commit(PROJECT_PURCHASE_LISTS, res.data.list);
            commit(PURCHASE_LASTPAGEPRO, res.data.lastPage);
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //保存战略集采备案
    projectPurchaseSave({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecordPurchase/save",
        data,
        "post"
      )
        .then((result) => {
          if (result) {
            return Promise.resolve(result);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //修改战略集采备案
    projectPurchaseUpdate({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecordPurchase/update",
        data
      )
        .then((result) => {
          if (result) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取战略集采备案详情
    getProjectPurchaseById({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecordPurchase/getProjectById",
        data,
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    // 分页查询-集采备案公示列表
    getPageProjectPurchasePublicity({ commit }, data) {
      commit(PURCHASE_PAGENOPRO, data.pageNo);
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecordPurchase/pageNotice",
        data
      )
        .then((res) => {
          console.log("集采备案公示列表 res:", res);
          if (res.code == 200) {
            commit(PROJECT_PURCHASE_PUBLICITY_LISTS, res.data.list);
            commit(PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO, res.data.lastPage);
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    /*工程备案-公海*/

    // 分页获取工程备案-公海列表
    getPageProjectOpen({ commit }, data) {
      return tokenCall("/mxoa/projectRecordOpen/page", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    // 认领公海项目
    claimProject({ commit }, data) {
      return tokenCall("/mxoa/projectRecordOpen/doClaim", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    // 放弃项目，项目流入公海
    abandonProject({ commit }, data) {
      return tokenCall("/mxoa/projectRecordOpen/doAbandon", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    // 获取用户已备案产品总金额
    getUserRecAmount({ commit }, data) {
      return tokenCall("/mxoa/projectRecordOpen/getUserRecAmount", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    // 获取部门已备案产品总金额
    getDepartRecAmount({ commit }, data) {
      return tokenCall(
        "/mxoa/projectRecordOpen/getDepartRecAmount",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    /*********************续备********************/

    //获取自己可续备的工程备案
    listCanReRecord({ commit }) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/listCanReRecord",
        {},
        "get"
      )
        .then((result) => {
          if (result && result.data) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //分页获取工程续备案
    getPageProjectC({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall("/mxoa/projectre/page", data)
        .then((res) => {
          if (res.code == 200) {
            commit(PROJECT_LISTS, res.data.list);
            commit(LASTPAGEPRO, res.data.lastPage);
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //新增续备案
    createProtectionC({ commit }, data) {
      return tokenCall("/mxoa/projectre/create", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //修改续备案
    updateProtectionC({ commit }, data) {
      return tokenCall("/mxoa/projectre/update", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取工程续备详情
    getProjectCdetails({ commit }, data) {
      return tokenCall("/mxoa/projectre/details", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    /*公示公告、新品发布、制度管理*/
    /*分页获取内容*/
    getPageContent({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall("/mxoa/oa/pageContent", data, "get")
        .then((res) => {
          if (res.code == 200) {
            commit(NEW_LISTS, res.data.list);
            commit(LASTPAGEPRO, res.data.lastPage);
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取内容详情
    getPageDetail({ commit }, data) {
      return tokenCall("/mxoa/oa/getContent", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //法人授权
    legalAuthSave({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/legalAuth/save", data)
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    legalAuthPage({ commit }, data) {
      commit(PAGENOPRO, data.pageNo);
      return tokenCall("/mxoa/legalAuth/page", data)
        .then((res) => {
          if (res.code == 200) {
            commit(AUTH_LISTS, res.data.list);
            commit(LASTPAGEPRO, res.data.lastPage);
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //详情
    getAuthByRecId({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/legalAuth/info",
        data,
        "get"
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    legalAuthCommit({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/legalAuth/commit",
        data,
        "get"
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    legalAuthRemove({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/legalAuth/remove",
        data,
        "get"
      )
        .then((result) => {
          if (result.code == 200) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 专卖店
    pageProShop({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/proshop/page", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    commitProShop({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/commit",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    updateProShop({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/proshop/update", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    createProShop({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/proshop/save", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    getProshop({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/getProshop",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    selectBrands({ commit }, data) {
      let reData = {
        brandName: "",
      };
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/mall/brand/selectBrands",
        reData,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    getMarkets({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/proshop/getMarkets", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    pageNotice({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/notice/page",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    pageInst({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + "/mxoa/proshop/inst/page", data)
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //增加公示异议
    addDissent({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/notice/addDissent",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取公示异议
    selectDissents({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/notice/selectDissents",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //增加-战略集采备案公示异议
    createPurchaseDissents({ commit }, data) {
      console.log("createPurchaseDissents data:", data);
      return tokenCall(
        Constant.tokenCallUrl +
          "/mxoa/projectRecordPurchase/createNoticeSuggest",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取-战略集采备案公示异议
    listPurchaseDissents({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecordPurchase/selectDissents",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //入参：
    // {
    //     auitResult: 审核结果，1 通过 0不通过
    //     proshopId： 专卖店ID，
    //     auditDesc： 审核备注
    //   }
    auditProshop({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/auditProshop",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    getAuditAuth({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/getAuditAuth",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 保存开店图片
    saveOpenImage({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/proshop/saveOpenImage",
        data,
        "post"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 获取成交率
    getDoneRate({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/projectRecord/getDoneRate",
        data,
        "post"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    getRateDepartSubs({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sm/depart/getDepartSubs",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    [PROJECT_LISTS](state, list) {
      if (state.pageNoPro == 1) {
        state.projectLists = [];
      }

      state.projectLists = state.projectLists.concat(list);
    },
    [NEW_LISTS](state, list) {
      if (state.pageNoPro == 1) {
        state.newLists = [];
      }

      state.newLists = state.newLists.concat(list);
    },
    [AUTH_LISTS](state, list) {
      if (state.pageNoPro == 1) {
        state.authLists = [];
      }

      state.authLists = state.authLists.concat(list);
    },
    [PAGENOPRO](state, pageNo) {
      state.pageNoPro = pageNo;
    },
    [LASTPAGEPRO](state, lastPagePro) {
      state.lastPagePro = lastPagePro;
    },

    [PROJECT_PURCHASE_LISTS](state, list) {
      if (state.purchasePageNoPro == 1) {
        state.projectPurchaseLists = [];
      }

      state.projectPurchaseLists = state.projectPurchaseLists.concat(list);
    },

    [PURCHASE_PAGENOPRO](state, pageNo) {
      state.purchasePageNoPro = pageNo;
    },
    [PURCHASE_LASTPAGEPRO](state, lastPagePro) {
      state.purchaseLastPagePro = lastPagePro;
    },

    [PROJECT_PURCHASE_PUBLICITY_LISTS](state, list) {
      if (state.purchasePageNoPro == 1) {
        state.projectPurchaseLists = [];
      }

      state.projectPurchasePublicityLists =
        state.projectPurchasePublicityLists.concat(list);
    },

    [PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO](state, lastPagePro) {
      state.projectPurchasePublicityLastPagePro = lastPagePro;
    },
  },
  getters: {
    projectLists: (state) => {
      return state.projectLists;
    },
    pageNoPro: (state) => {
      return state.pageNoPro;
    },
    lastPagePro: (state) => {
      return state.lastPagePro;
    },
    newLists: (state) => {
      return state.newLists;
    },
    authLists: (state) => {
      return state.authLists;
    },

    projectPurchaseLists: (state) => {
      return state.projectPurchaseLists;
    },
    purchasePageNoPro: (state) => {
      return state.purchasePageNoPro;
    },
    purchaseLastPagePro: (state) => {
      return state.purchaseLastPagePro;
    },

    projectPurchasePublicityLists: (state) => {
      return state.projectPurchasePublicityLists;
    },
    projectPurchasePublicityPageNoPro: (state) => {
      return state.projectPurchasePublicityPageNoPro;
    },
    projectPurchasePublicityLastPagePro: (state) => {
      return state.projectPurchasePublicityLastPagePro;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/agency/index.js